import styled from "styled-components"

const AppRoot = styled.div`
  padding: 0;
  background: ${(props) => props.theme.color.primary};
`

export { AppRoot }
